module.exports = __webpack_public_path__ + "img/img0501.a1241cd2.png";